import { formatUIDateTime } from "../../../../../../utils/helpers"
import { DownloadIcon } from "../../../../../../icons"

export const toolbarActions = ({
 exportFileCSV,
 isCSVExportLoading
}) => {
  let actions = []

  actions = [
    ...actions,
    {
      label: isCSVExportLoading ? 'Export in curs...' : 'Export CSV',
      icon: <DownloadIcon />,
      onClick: isCSVExportLoading ? () => {} : exportFileCSV
    }
  ]

  return actions
}

export const getColumns = () => [
  {
    title: 'Furnizor',
    field: 'supplierName',
    align: 'left',
    type: 'string',
    render: row => `${row.supplierName} (${row?.supplierCode})`
  },
  {
    title: 'Cod magazin',
    field: 'shopCode',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Societate',
    field: 'parentSociety',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Tip suport',
    field: 'supportCode',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Sold',
    field: 'stock',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Ultima actualizare',
    field: 'lastUpdate',
    align: 'left',
    type: 'string',
    render: row => formatUIDateTime(row.lastUpdate)
  },
  {
    title: 'Actualizat de',
    field: 'lastUpdateBy',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Valoare actualizare FD',
    field: 'dsUpdateSupportStockTypeValue',
    align: 'left',
    type: 'string'
  }
]
